<template>
  <section>
    <div v-if="(isHome() || isViewAllPage()) && !isMyProfile()"
         class="hero"
         role="banner">
      <div class="hero-content">
        <div class="banner-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2Foasam-logo-transparancy.png?alt=media&token=4f64c14a-6b7b-4182-aa47-6a3a2b15fccb" alt="OASAM logo">
        </div>
        <h1 class="banner-text">2022 POSTERS</h1>
      </div>
    </div>
    <div v-if="isPodiumPage()"
         class="hero-podium"
         role="banner">
      <div class="hero-content">
        <div class="banner-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2Foasam-logo-transparancy.png?alt=media&token=4f64c14a-6b7b-4182-aa47-6a3a2b15fccb" alt="OASAM logo">
        </div>
        <h1 class="banner-text">PODIUM SESSIONS</h1>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  methods: {
    isHome: function () {
      return this.$route.fullPath.includes('home')
    },
    isViewAllPage: function () {
      return this.$route.fullPath.includes('viewAll')
    },
    isPodiumPage: function () {
      return this.$route.fullPath.includes('/explore/podium-sessions')
    },
    isMyProfile: function () {
      return this.$route.fullPath.includes('profile')
    }
  }
}

</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
@font-face {
  font-family: 'Cera Pro';
  src: url('/static/fonts/cera-pro/CeraPro-Bold.ttf');
  font-weight: 600;
  font-style: normal;
}
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FOASAM_banner_BG1.jpg?alt=media&token=ccc8c55a-ef3e-4f54-8d09-85b7fe6ecdd6");
  height: 450px;
  background-size: cover;
  background-position: center;
}
.hero-podium {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FOasam%2FOASAM_banner_BG2.jpg?alt=media&token=8ea8861a-6d0d-4249-adef-8d5592fbb57d");
  height: 450px;
  background-size: cover;
  background-position: center;
}
.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.banner-logo {
  width: 20rem;
}
.banner-text {
  font-family: 'Cera Pro' !important;
  color: white;
  font-weight: 600;
  font-size: 4rem;
  text-shadow: 2px 2px 4px #2f2f2f;
  text-align: center;
}
@include mobile {
  .banner-logo {
    width: 15rem;
  }
  .banner-text {
    font-size: 3rem;
  }
}
</style>
